import { axiosPrivate } from '../api/axios'
import { useEffect } from 'react'
import useRefreshToken from './useRefreshToken'
import useAuth from './useAuth'
import { useNavigate } from 'react-router-dom'

const useAxiosPrivate = () => {
    const navigate = useNavigate()
    const { refresh } = useRefreshToken()
    const { auth, setAuth }: any = useAuth()

    useEffect(() => {
        const requestIntercept = axiosPrivate.interceptors.request.use(
            (config) => {
                if (!config.headers['Authorization']) {
                    config.headers[
                        'Authorization'
                    ] = `Bearer ${auth?.accessToken}`
                }
                return config
            },
            (error) => Promise.reject(error)
        )

        const responseIntercept = axiosPrivate.interceptors.response.use(
            (response) => response,
            async (error) => {
                const prevRequest = error?.config

                if (error?.response?.status === 403) {
                    navigate('/unauthorized', { replace: true })
                    return error.response
                }

                if (error?.response?.status === 401 && !prevRequest?.sent) {
                    prevRequest.sent = true
                    const newAccessToken = await refresh()
                    prevRequest.headers[
                        'Authorization'
                    ] = `Bearer ${newAccessToken}`
                    return axiosPrivate(prevRequest)
                }

                if (error?.response?.status === 401) {
                    setAuth({})
                    navigate('/login')
                    return error.response
                }

                return Promise.reject(error)
            }
        )

        return () => {
            axiosPrivate.interceptors.request.eject(requestIntercept)
            axiosPrivate.interceptors.response.eject(responseIntercept)
        }
    }, [auth, refresh, navigate, setAuth])

    return axiosPrivate
}

export default useAxiosPrivate
